import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { EventContentObjectDataObject } from 'models/service';

export const deleteProgramEvent = async ({ eventId }: { eventId: string }) =>
  apiClient.delete<EventContentObjectDataObject, ApiClientResponse<EventContentObjectDataObject>>(
    routes.events.delete(eventId),
  );
